// Pure derivation of the Regular / OT / UT figures in the summary bar the Work
// Schedule page shows under its schedule form (PRD_WorkScheduleManagement C16).
//
// A stated COPY of Step 3's inline useMemo (StepEmployment.js:212-229). The
// wizard is frozen (C8) and does not import this, so the test beside this file
// pins THIS copy's numbers only — a later change to Step 3's maths would not go
// red here. Accepted, and written down so nobody mistakes the test for a drift
// guard.

/**
 * Step 3's first-working-day pick, verbatim including its guard: a doc that
 * carries no workSchedule at all must not throw (C2). Shared with
 * workScheduleService.readSchedule so both surfaces choose the same day for a
 * non-uniform legacy schedule.
 */
export const firstWorkingDay = (workSchedule) =>
  Object.values(workSchedule || {}).find((d) => d?.isWorkingDay);

/**
 * @param {Object} workSchedule - employment.workSchedule (seven day keys)
 * @param {number|null} hoursPerDay - attendancePolicy → payrollRates → 8 (page-resolved)
 * @returns {{ ot: number, ut: number, regularHours: number } | null} null when
 *   hoursPerDay is unknown or no working day carries both times
 */
export const scheduleOtUt = (workSchedule, hoursPerDay) => {
  if (hoursPerDay == null) return null;
  const firstWorkDay = firstWorkingDay(workSchedule);
  if (!firstWorkDay?.startTime || !firstWorkDay?.endTime) return null;

  const [sh, sm] = firstWorkDay.startTime.split(':').map(Number);
  const [eh, em] = firstWorkDay.endTime.split(':').map(Number);
  let shiftMinutes = (eh * 60 + em) - (sh * 60 + sm);
  if (shiftMinutes <= 0) shiftMinutes += 24 * 60; // cross-midnight
  const breakMin = firstWorkDay.breakDuration || 0;
  const paidHours = (shiftMinutes - breakMin) / 60;

  const ot = Math.max(0, Math.round((paidHours - hoursPerDay) * 100) / 100);
  const ut = Math.max(0, Math.round((hoursPerDay - paidHours) * 100) / 100);
  const regularHours = Math.min(hoursPerDay, Math.round(paidHours * 100) / 100);
  return { ot, ut, regularHours };
};
